import React from 'react';
import { HeartIcon, ShieldIcon, BrainIcon, AlertTriangleIcon } from 'lucide-react';
export function UMPSection() {
  return <section className="py-4 bg-gradient-to-b from-white to-blue-50" data-id="element-443">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-444">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-445">
          <h2 className="text-3xl font-bold text-blue-900 mb-4" data-id="element-446">
            If You Feel Lost, It's Not Your Fault
          </h2>
          <div className="h-1 w-20 bg-yellow-500 mx-auto mb-6" data-id="element-447"></div>
          <p className="text-lg text-gray-700 mb-6" data-id="element-448">
            You've Googled random recipes. You've copied tips from Instagram.
            You've asked your pediatrician, your mom group, your neighbor…
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-449">
            And still, your baby turns away, clams up, cries.
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-450">
            And something inside you begins to break.
          </p>
          <p className="text-xl font-bold text-blue-900 mb-6 italic" data-id="element-451">
            "Am I doing something wrong?"
          </p>
          <p className="text-lg text-gray-700 mb-8" data-id="element-452">
            Breathe. You are not alone.
          </p>
          <p className="text-lg text-gray-700 font-medium" data-id="element-453">
            Over 10,000 moms felt the same… until they discovered this system.
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-8 max-w-3xl mx-auto mt-12" data-id="element-454">
          <h3 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-455">
            The Invisible Mistake 97% Make
          </h3>
          <p className="text-lg text-gray-700 mb-6" data-id="element-456">
            In a study of 500 families I worked with, a pattern emerged:
          </p>
          <p className="text-xl font-bold text-blue-900 mb-4 text-center" data-id="element-457">
            The problem isn't the food. It's daily improvisation.
          </p>
          <p className="text-lg text-gray-700 mb-6" data-id="element-458">
            That daily scramble activates stress your baby can sense
            your baby can feel.
          </p>
          <p className="text-lg font-medium text-gray-800 mb-4" data-id="element-459">
            Science is clear:
          </p>
          <div className="space-y-4 mb-6 pl-4 border-l-4 border-yellow-500" data-id="element-460">
            <p className="text-lg text-gray-700" data-id="element-461">
              • Babies detect maternal stress in 89% of cases
            </p>
            <p className="text-lg text-gray-700" data-id="element-462">
              • Anxiety during meals lowers food acceptance by 73%
            </p>
            <p className="text-lg text-gray-700" data-id="element-463">
              • Lack of structure causes food refusal in 94% of cases
            </p>
          </div>
          <p className="text-xl font-bold text-blue-900 text-center mt-6" data-id="element-464">
            It's not about cooking perfectly. It's about having a plan.
          </p>
        </div>
      </div>
    </section>;
}